function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "loga",
  d: "M22.186 3.807A12.904 12.904 0 0 0 12.996 0 12.922 12.922 0 0 0 3.8 3.808c-5.068 5.069-5.068 13.315 0 18.384A12.915 12.915 0 0 0 12.996 26a12.92 12.92 0 0 0 9.193-3.806 12.915 12.915 0 0 0 3.808-9.192c0-3.475-1.353-6.74-3.811-9.195zm-9.19 20.568c-3.04 0-5.897-1.184-8.045-3.332A11.296 11.296 0 0 1 1.623 13c0-3.042 1.182-5.9 3.327-8.044a11.3 11.3 0 0 1 8.045-3.33c3.037 0 5.895 1.182 8.043 3.328a11.306 11.306 0 0 1 3.335 8.047 11.3 11.3 0 0 1-3.333 8.044 11.298 11.298 0 0 1-8.043 3.33zM13 6.5a.59.59 0 0 0-.59.59v5.32H7.09a.59.59 0 1 0 0 1.18h5.32v5.32a.59.59 0 1 0 1.18 0v-5.32h5.32a.59.59 0 1 0 0-1.18h-5.32V7.09A.59.59 0 0 0 13 6.5z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "logb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#loga"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#loga"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#85868F",
  mask: "url(#logb)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h26v26H0z"
})));

const SvgBmLog = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBmLog, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bm-log.558bf8e3.svg";
export { ForwardRef as ReactComponent };